import { readableColor } from "polished";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";

export const ResumeCourses = ({ children, sortControl }) => {
  const theme = useTheme();
  const { lang } = useAuth();
  return (
    <>
      <div
        className="wrapper fon-sec-car"
        style={{ backgroundColor: "rgb(14, 15, 28)", padding: "30px 0" }}
      >
        <div className="page-content-shell">
            <div>
              {/* <div className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-6 tablet:gap-19 justify-items-center">
                {children}
              </div> */}
              <div className="flex items-center justify-between w-full mb-2 flex-wrap gap-3">
               <h1
                   className="tit-color font-ubuntu font-[900] m-0"
                   style={{ color: theme.mode === "dark" ? "#fff" : "#000" }}
                 >
                   {lang["Home"].title}
                 </h1>
                {sortControl}
              </div>
              <div className="grid grid-cols-1 min-[700px]:grid-cols-2 laptop:grid-cols-3 min-[1380px]:grid-cols-4 gap-6 tablet:gap-8 justify-items-center">
                {children}
              </div>
            </div>
        </div>
      </div>
    </>
  );
};
